(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[208],{

/***/ 4146:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/order-of-merit/[...slug]",
      function () {
        return __webpack_require__(7013);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _GridElement__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5299);
/* harmony import */ var _GridWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2409);
/* harmony import */ var _public_bg_graphics_arrows_in_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9248);





var BackgroundGraphic = function(param) {
    var _bgHeight = param.bgHeight, bgHeight = _bgHeight === void 0 ? 70 : _bgHeight, _align = param.align, align = _align === void 0 ? "right" : _align;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_GridWrapper__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        style: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            zIndex: -1
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_GridElement__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            gridLayout: align === "right" ? [
                [
                    961,
                    10,
                    7
                ],
                [
                    1401,
                    19,
                    14
                ], 
            ] : [
                [
                    961,
                    1,
                    7
                ],
                [
                    1401,
                    1,
                    14
                ], 
            ],
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    position: "relative",
                    height: "".concat(bgHeight, "vh")
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                    src: _public_bg_graphics_arrows_in_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
                    alt: "background arrows",
                    layout: "fill",
                    objectFit: "contain",
                    priority: true
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BackgroundGraphic);


/***/ }),

/***/ 7443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _BackgroundGraphic__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _BackgroundGraphic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(373);



/***/ }),

/***/ 5748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Tabs_Tabs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2481);


var OrderOfMeritPageTabs = function(param) {
    var tabs = param.tabs, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            marginTop: "30px",
            marginBottom: "50px"
        },
        children: [
            (tabs === null || tabs === void 0 ? void 0 : tabs.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Tabs_Tabs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                tabs: tabs,
                logoLink: "/icons/nextgolftour_logo_icon.svg",
                logoTitle: "Order of Merit",
                pageSlug: "order-of-merit"
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OrderOfMeritPageTabs);


/***/ }),

/***/ 7013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ OrderOfMeritPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _storyblok_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9036);
/* harmony import */ var _components_BackgroundGraphic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7443);
/* harmony import */ var _components_OrderOfMeritPageTabs_OrderOfMeritPageTabs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5748);
/* harmony import */ var _components_OOMLeaderboard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8437);





var __N_SSG = true;
function OrderOfMeritPage(param) {
    var story = param.story, tabs = param.tabs, csvFiles = param.csvFiles;
    var ref, ref1;
    story = (0,_storyblok_react__WEBPACK_IMPORTED_MODULE_1__/* .useStoryblokState */ .f0)(story);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BackgroundGraphic__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                align: "right"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_OrderOfMeritPageTabs_OrderOfMeritPageTabs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                tabs: tabs,
                children: [
                    (story === null || story === void 0 ? void 0 : story.slug) === "rankings" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_OOMLeaderboard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        blok: story === null || story === void 0 ? void 0 : (ref = story.content) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1[0],
                        csvFiles: csvFiles
                    }, story._uid),
                    (story === null || story === void 0 ? void 0 : story.slug) !== "rankings" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storyblok_react__WEBPACK_IMPORTED_MODULE_1__/* .StoryblokComponent */ .Xj, {
                        blok: story.content
                    }, story._uid)
                ]
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(4146); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);